/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProjectTagsResponse } from '../../models/project-tags-response';

export interface ProjectsControllerGetTags$Params {

/**
 * Project id.
 */
  id: string;
}

export function projectsControllerGetTags(http: HttpClient, rootUrl: string, params: ProjectsControllerGetTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectTagsResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerGetTags.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectTagsResponse>;
    })
  );
}

projectsControllerGetTags.PATH = '/planning-projects/v1-preview/projects/{id}/tags';
